import React from 'react';
import { Button } from '@material-ui/core';
import { mdiDownload } from '@mdi/js';
import Icon from '@mdi/react';
import styled from 'styled-components';
import { IconSize } from '../../../../lib';
import { modularScale } from '../../../../utils';
const StyledDownloadText = styled.span `
    font-size: ${modularScale(-1)};
    padding-left: 0.325rem;
    letter-spacing: 0.3px;
`;
const PDFDownloadButton = ({ href }) => {
    const onDownloadClick = (event) => event.stopPropagation();
    return (React.createElement(Button, { onClick: onDownloadClick, href: href, download: true, component: "a", color: "primary" },
        React.createElement(Icon, { path: mdiDownload, size: IconSize.Small }),
        React.createElement(StyledDownloadText, null, "Download")));
};
export default PDFDownloadButton;
//# sourceMappingURL=PDFDownloadButton.js.map